import script from "./PagePanel.vue?vue&type=script&setup=true&lang=js"
export * from "./PagePanel.vue?vue&type=script&setup=true&lang=js"

import "./PagePanel.vue?vue&type=style&index=0&id=d39d935c&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d39d935c"]])

export default __exports__